/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	__webpack_require__(4);
	__webpack_require__(2);
	__webpack_require__(3);
	__webpack_require__(5);
	__webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/**
	 * [回到顶部]
	 */
	var $backToTopEle = $('.btn-top').click(function() {
	    $('html, body').animate({
	        scrollTop: 0
	    }, 120);
	});
	
	$(window).bind('scroll', function() {
	    var st = $(document).scrollTop();
	    if (st > 0) {
	        $backToTopEle.css('display', 'block');
	    } else {
	        $backToTopEle.css('display', 'none');
	    }
	});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/**
	 * [搜索]
	 */
	
	function statistics(adskey) {
	    window._jc_ping = window._jc_ping || [];
	    _jc_ping.push([
	        '_trackBlockClick',
	        adskey
	    ]);
	}
	
	function getIndex(parents, a) {
	    var index = '';
	    parents.find('a').each(function(i) {
	        if (this == a) {
	            index = i;
	            return false;
	        }
	    });
	    return index;
	}
	
	$.each([
	    ['#header', 'eyARze'],
	    ['#mainList', 'AJZvYv'],
	    ['.side .focus-in', 'NBzQje'], //焦点图
	    ['.rec-reading', 'fyeYri'], //推荐阅读
	    ['.hao-welfare', 'byANBj'], //发号福利
	    ['.game-test', 'yUJvMn'],
	    ['.bi-waiting-list', '6jmMfq'],
	    ['.bi-game-list', 'vEFVN3']
	], function(i, item) {
	    $(item[0]).attr('data-bi', item[1]);
	});
	
	$('body').on('mousedown', '[data-bi] a', function() {
	    var a = $(this);
	    var parents = a.parents('[data-bi]');
	    var adskey = parents.data('bi');
	    var index = getIndex(parents, a[0]);
	    if (adskey) {
	        statistics(adskey + '|' + index);
	    }
	});
	
	$('.search-form').on('submit', function() {
	    statistics('eyARze|15');
	});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	 * [发号福利 标签切换]
	 */
	if ($('.js-tab').length) {
	    $('.js-tab').each(function() {
	        var _this = $(this);
	        var $tab = _this.find('.tab-pn').slick({
	            dots: false,
	            autoplay: false,
	            arrows: false
	        });
	        _this.find('.tab li:eq(0)').addClass('current');
	        _this.find('.tab li').click(function() {
	            var i = $(this).index();
	            $(this).addClass('current').siblings().removeClass('current');
	            $tab.slickGoTo(i);
	        });
	        $('.hao-welfare .slick-slide').show();
	    });
	}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	 * [加载更多]
	 */
	var matchHtmlRegExp = /["'&<>]/;
	
	function escapeHtml(string) {
	    var str = '' + string;
	    var match = matchHtmlRegExp.exec(str);
	    if (!match) {
	        return str;
	    }
	    var escape;
	    var html = '';
	    var index = 0;
	    var lastIndex = 0;
	
	    for (index = match.index; index < str.length; index++) {
	        switch (str.charCodeAt(index)) {
	            case 34: // "
	                escape = '&quot;';
	                break;
	            case 38: // &
	                escape = '&amp;';
	                break;
	            case 39: // '
	                escape = '&#39;';
	                break;
	            case 60: // <
	                escape = '&lt;';
	                break;
	            case 62: // >
	                escape = '&gt;';
	                break;
	            default:
	                continue;
	        }
	        if (lastIndex !== index) {
	            html += str.substring(lastIndex, index);
	        }
	        lastIndex = index + 1;
	        html += escape;
	    }
	    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	
	var tpl = '' +
	    '<li>' +
	    '<a href="{{url}}" target="_blank" class="con">' +
	    '<span class="type">{{type}}</span>' +
	    '<strong class="tit">{{title}}</strong>' +
	    '<strong class="tit-sub">{{subTitle}}</strong>' +
	    '<img src="{{img}}" alt="" width="365" height="475" />' +
	    '<b class="line"></b>' +
	    '</a>' +
	    '</li>';
	
	function render(data) {
	    var html = '';
	    $.each(data, function(i, item) {
	        html += tpl.replace(/\{\{(\w+)\}\}/img, function(w, key) {
	            return escapeHtml(item[key]);
	        });
	    });
	    $('.focus-list').html(html);
	    new ue.Focus($('.focus'));
	}
	
	$.ajax({
	    url: 'http://interface.17173.com/focus/indexList_2018.jsonp',
	    data: {
	        url: 'http://www.17173.com/2018/focus/inc-focus.shtml'
	    },
	    dataType: 'jsonp'
	}).done(function(data) {
	    render(data.data);
	});
	
	//对游戏进行缓存
	var gameInfoCache = {};
	
	function getGameCode($dom) {
	    var code = $dom.data('gamecodes') || '';
	    code = (code + '').split(',');
	    return code.pop();
	}
	
	function getGameInfo($el) {
	    var cache = {};
	    var codes = [];
	    var $gamecodes = $el.find('[data-gamecodes]');
	    $gamecodes.each(function() {
	        var target = $(this);
	        var gamecode = getGameCode(target);
	        if (!gameInfoCache[gamecode] && !cache[gamecode] && gamecode) {
	            codes.push(gamecode);
	            cache[gamecode] = true;
	        }
	    });
	    getGameData(codes, function(data) {
	        $.each(data, function(i, item) {
	            gameInfoCache[item.gameCode] = item;
	        });
	        $gamecodes.each(function() {
	            var target = $(this);
	            var code = getGameCode(target);
	            if (code) {
	                target.html(renderGameTag(gameInfoCache[code]));
	            }
	        });
	    });
	}
	
	function getGameData(codes, callback) {
	    if (!codes || codes.length < 1) {
	        callback([]);
	        return;
	    }
	    $.ajax({
	        url: '//interface.17173.com/game/infoByCode.jsonp',
	        data: {
	            gameCodes: codes.join(',')
	        },
	        dataType: 'jsonp'
	    }).done(function(data) {
	        callback(data.data);
	    });
	}
	var nameMap = {
	    channelUrl: '专区',
	    downloadUrl: '下载',
	    gameOfficialUrl: '官网',
	    giftList: '礼包'
	};
	
	function renderGameTag(item) {
	    var html = '';
	    var url;
	    for (var key in item) {
	        if (nameMap[key] && item[key]) {
	            url = Object.prototype.toString.call(item[key]) == '[object Array]' ? item[key][0].giftUrl : item[key];
	            html += '<a href="' + escapeHtml(url) + '" target="_blank" class="tag"> ' + nameMap[key] + ' </a>';
	        }
	    }
	    return html;
	}
	pandora.use(['loadlist', 'thumb'], function(LoadList, Thumb) {
	    var mainList = $('#mainList');
	    var contentKeys = {};
	
	    mainList.find('[data-key]').each(function() {
	        var key = $(this).data('key');
	        contentKeys[key] = key;
	    });
	
	    var list = new LoadList({
	        element: mainList,
	        categoryIds: mainList.data('ids'),
	        pageNo: 3,
	        autoLoad: false
	    });
	
	    var thumb = new Thumb({
	        element: mainList,
	        selecter: '.avatar img'
	    });
	
	    list.on('load', function(e, res) {
	        var key, data = res.data;
	        for (var i = data.length - 1; i >= 0; i--) {
	            key = data[i].contentKey;
	            if (contentKeys[key]) {
	                data.splice(i, 1);
	            } else {
	                contentKeys[key] = key;
	            }
	        }
	        if (data.length < 5) {
	            list.nextPage();
	        }
	    });
	
	    list.on('listRender', function(e, $html) {
	        getGameInfo($html);
	        thumb.handle($html);
	    });
	
	});
	getGameInfo($('#mainList'));

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/**
	 * [新游期待榜、热门游戏榜]
	 */
	if ($('.js-rank').length) {
	    $('.js-rank').each(function() {
	        var currentObj, _this = $(this);
	        for (var i = 0; i < $('li', _this).length; i++) {
	            currentObj = $('li:eq(' + i + ')', _this);
	            currentObj.mouseenter(function() {
	                $(this).addClass('active').siblings().removeClass('active');
	            }).find('.c1 em').html(i + 1);
	        }
	        $('li:eq(0)', _this).addClass('active');
	    });
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * [initSearch 搜索]
	 * @param  {[String]} _keyword [关键词]
	 */
	function initSearch(_keyword) {
	    var keyword = $('.search-form .keyword');
	    var preValue = _keyword;
	
	    function setStyle(isEmp) {
	        keyword.css('color', isEmp ? '#999' : '#333');
	    }
	    keyword.val(_keyword);
	    setStyle(true);
	    keyword.focus(function() {
	        if (preValue == keyword.val()) {
	            keyword.val('');
	            setStyle(false);
	        }
	    });
	    keyword.blur(function() {
	        if (keyword.val() == '') {
	            keyword.val(preValue);
	            setStyle(true);
	        }
	    });
	}
	
	/**
	 * 与首页搜索框关键词内容保持同步
	 */
	
	$.ajax({
	    url: '//interface.17173.com/inc/getContent.jsonp',
	    dataType: 'jsonp',
	    data: {
	        url: 'http://www.17173.com/2016v2/inc/inc-search.shtml'
	    }
	}).done(function(data) {
	    var keyword = $(data).find('input[name=keyword]').val();
	    initSearch(keyword);
	});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.bundle.js?688d7e7f